<script setup>
import {defineEmits, defineProps, onMounted, ref} from "vue";
import {copyText} from "@/utils/func";

const props = defineProps({
  orderFlag: Boolean,
  orderDat: Object,
  type: Object
})
const emit = defineEmits(["close"])
const orderFlag = ref(false)
onMounted(() => {
  orderFlag.value = props.orderFlag
})
const closed = () => {
  emit("close")
  orderFlag.value = false
}
const copy = val => {
  copyText(val)
  if (props.orderDat.hasCoupon.length <= 1) {
    orderFlag.value = false
    emit("close")
  }
}
</script>

<template>
  <el-dialog v-model="orderFlag" :style="props.type.style" width="95%" class="order-dialog" top="25px"
             @close="closed">
    <template #header>
      <h3 class="success-title">兑换成功</h3>
      <h3>MELAND {{ props.orderDat?.couponItems?.name }}</h3>
    </template>
    <div class="order-info">
      <el-text :type="props.type?.login === 'xm_air'?'primary':'danger'" class="tips">
        使用方法:请复制兑换码→打开“MELAND”微信小程序:→【我的】-兑换中心→粘贴“兑换码”后即可激活，选择兑换门店，到门店出示券码核销使用。
      </el-text>
      <div class="code-lst">
        <div class="code-item" v-for="(val,inx) in props.orderDat?.hasCoupon" :key="inx"
             :class="props.orderDat?.hasCoupon.length > 1?'code-flex':'code-one'">
          <div class="code-item-box">{{ val.code }}</div>
          <div class="code-copy" @click="copy(val)">
            点击复制兑换码
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<style scoped lang="less">
.order-info {
  padding: 15px;

  .tips {
    line-height: 1.75;
    text-align: justify-all;
    display: block;
  }

  .code-item {
    margin-top: 15px;
    font-size: 1.25rem;

    .code-item-box {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .code-copy {
      color: var(--theme-copy-color);
    }

    &.code-one {
      text-align: center;
      display: block;
    }

    &.code-flex {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .code-item-box {
        flex-basis: 55%;
      }

      .code-copy {
        font-size: .85rem;
      }
    }
  }
}
</style>
